import { FILTER_STATUSES, FILTER_TAGS } from './constants';
import { CheckboxActive, CheckboxDefault, FilterIcon } from '@/assets/svg';
import CustomAsyncAutoComplete from '@/new-components/CustomAsyncAutoComplete';
import CustomSelectContainer from '@/new-components/CustomSelectOld/CustomSelectContainer';
import {
  Button,
  Toolbar,
  Box,
  withStyles,
  TextField,
  Checkbox,
  Paper,
  makeStyles,
} from '@material-ui/core';
import { isBoolean, isEmpty } from 'lodash';
import React, { useMemo } from 'react';

const CustomButton = withStyles({
  label: {
    fontWeight: 700,
  },
})(Button);

const CustomFilterInput = withStyles({
  root: {
    '& .MuiOutlinedInput-root': {
      height: 40,
      borderRadius: 8,

      '& input': {
        padding: 0,
        marginLeft: 0,
      },
      '& input::placeholder': {
        opacity: 1,
        color: '#999999',
      },
    },
  },
})(TextField);

const useStyles = makeStyles((theme) => ({
  isBtnSelected: {
    border: 'none',
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.primary.main,
  },
  checkboxIcon: {
    padding: 0,
    marginRight: 4,
  },
  tagStyle: {
    maxWidth: 'calc(100% - 60px)', // Adjust based on your needs
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  selectWrapper: {
    '& .MuiIconButton-root:hover': {
      backgroundColor: 'transparent',
    },

    '& .MuiAutocomplete-option': {
      padding: 8,
      borderRadius: 8,
      margin: '2px 8px',
      '&:first-child': {
        marginTop: 8,
      },
      '&:last-child': {
        marginBottom: 8,
      },
      '&.MuiAutocomplete-option[aria-selected="true"]': {
        backgroundColor: '#ffffff',
      },
    },
  },
}));

const GroupToolbar = ({
  isLocation = false,
  searchKey,
  filterOption,
  onFilterOptionClear,
  onFilterOptionChange,
  onResetFilterOps,
  platoNames,
  listPlatoNames,
}) => {
  const classes = useStyles();

  const isEmptyFilterParams = useMemo(() => {
    const filterKeys = Object.keys(filterOption);
    return (
      isEmpty(searchKey) &&
      filterKeys.every((key) =>
        isBoolean(filterOption[key])
          ? !filterOption[key]
          : isEmpty(filterOption[key])
      )
    );
  }, [filterOption, searchKey]);

  return (
    <Toolbar>
      <Box
        display="flex"
        flex={1}
        justifyContent="space-between"
        alignItems="center"
      >
        <Box display="flex" gridGap={12}>
          {isLocation && (
            <CustomSelectContainer
              isFullWidth
              filterValue={filterOption.locationTypes || []}
              data={FILTER_TAGS}
              renderValue={
                !isEmpty(filterOption.locationTypes)
                  ? `Tags (${filterOption.locationTypes.length})`
                  : 'All tags'
              }
              onClear={onFilterOptionClear('locationTypes')}
              onChange={onFilterOptionChange('locationTypes')}
              labelSelectAll={'All tags'}
              useSelectAll
              checkedAll={
                FILTER_TAGS.length === filterOption.locationTypes.length
              }
            />
          )}

          <CustomSelectContainer
            isFullWidth
            filterValue={filterOption?.statuses || []}
            data={FILTER_STATUSES}
            renderValue={
              !isEmpty(filterOption?.statuses)
                ? `Statuses (${filterOption?.statuses?.length})`
                : 'All statuses'
            }
            onClear={onFilterOptionClear('statuses')}
            onChange={onFilterOptionChange('statuses')}
            labelSelectAll={'All statuses'}
            useSelectAll
            checkedAll={
              FILTER_STATUSES.length === filterOption?.statuses?.length
            }
          />
          {isLocation && (
            <CustomSelectContainer
              isFullWidth
              filterValue={platoNames || []}
              data={listPlatoNames?.map((it) => ({ key: it, value: it })) || []}
              renderValue={
                !isEmpty(platoNames)
                  ? `Plato (${platoNames?.length})`
                  : 'All Plato ID'
              }
              onClear={onFilterOptionClear('platoNames')}
              onChange={onFilterOptionChange('platoNames')}
              labelSelectAll={'All Plato ID'}
              useSelectAll
              checkedAll={listPlatoNames?.length === platoNames?.length}
            />
          )}
        </Box>
        <CustomButton disabled={isEmptyFilterParams} onClick={onResetFilterOps}>
          Reset
        </CustomButton>
      </Box>
    </Toolbar>
  );
};

export default GroupToolbar;
